import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import * as ApiNotification from '../interfaces/api/notification';

@Injectable({
  providedIn: 'root',
})
export class NotificationService extends BaseService {
  private urlNotification = `${this.apiUrl}/notification`;

  constructor(private http: HttpClient) {
    super();
  }

  getNotifications(options?: { page: number; per_page: number }) {
    const url = new URL(`${this.urlNotification}`);

    if (options?.page) {
      url.searchParams.set('page', String(options?.page));
    }

    if (options?.per_page) {
      url.searchParams.set('per_page', String(options?.per_page));
    }

    return this.http.get<ApiNotification.ResponseNotifications>(url.toString());
  }

  readOneNotification(chatId: number) {
    return this.http.put<ApiNotification.ResponseReadAllNotifications>(`${this.urlNotification}/${chatId}/ack`, {});
  }

  readAllNotifications() {
    return this.http.put<ApiNotification.ResponseReadAllNotifications>(`${this.urlNotification}/ack`, {});
  }

  getChatNotifications() {
    return this.http.get<ApiNotification.ResponseNotifications>(`${this.urlNotification}/chat`);
  }

  readAllChatNotifications() {
    return this.http.put<ApiNotification.ResponseReadAllNotifications>(`${this.urlNotification}/chat/ack`, {});
  }
}
